import { useState } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';

export const BareModal = ({
    controller: {
        visible,
        hide,
    },
    title,
    children,
}) => {
    return (
        <BootstrapModal className="modal-base" show={visible} onHide={hide}>
            <BootstrapModal.Header closeButton>
                <BootstrapModal.Title>
                    { title }
                </BootstrapModal.Title>
            </BootstrapModal.Header>
            { children }
        </BootstrapModal>
    );
}
